import Router from '@netx/core/lib/netx-routers-app';

/**
 * App router instance
 */
export const router = new Router();
export const appRouter = router;
router.routes = {};

dispatcher.on('route:invalid', (route: any) => {
	router.home();
});

export default router;
